import { Box, Button, Card, CardActions, CardContent, CardMedia, Divider, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import allItems from '../data/all_items.json';

const Products = () => {
    const [productsByCategory, setProductsByCategory] = useState({});

    const scrollToCategory = (category) => {
        const element = document.getElementById(category);
        if (element) {
            window.scrollTo({
                top: element.offsetTop - 160,
                behavior: 'smooth',
            });
        }
    };

    useEffect(() => {
        const enrichedData = allItems?.map(item => ({
            ...item,
            url: item.url.replace('www.etsy.com', 'kbrosleather.etsy.com'),
            name: item.name.replace('&#39;', "'"),
            category: item.name.toLowerCase().includes('wallet')
                ? 'Wallets'
                : item.name.toLowerCase().includes('key')
                    ? 'Keychains'
                    : item.name.toLowerCase().includes('bookmark')
                        ? 'Bookmarks'
                        : 'Other',
        }));

        const groupedByCategory = enrichedData.reduce((acc, item) => {
            if (!acc[item.category]) {
                acc[item.category] = [];
            }
            acc[item.category].push(item);
            return acc;
        }, {});

        setProductsByCategory(groupedByCategory);
    }, []);

    return (
        <Box sx={{ padding: 4, backgroundColor: '#f5f5f5' }}>
            <Typography variant="h4" component="h1" gutterBottom align="center" sx={{ marginBottom: 4 }}>
                Our Products
            </Typography>

            <Box
                sx={{
                    position: 'sticky',
                    top: 60,
                    zIndex: 1000,
                    backgroundColor: '#ffffff',
                    padding: 2,
                    boxShadow: 3,
                    marginBottom: 4,
                }}
            >
                <Grid container spacing={2} justifyContent="center">
                    {Object.keys(productsByCategory).filter(category => category !== 'Other').concat('Other')?.map(category => (
                        <Grid item key={category}>
                            <Button
                                variant="text"
                                onClick={() => scrollToCategory(category)}
                                sx={{ textTransform: 'none' }}
                                data-testid={`category-${category}`}
                            >
                                {category}
                            </Button>
                        </Grid>
                    ))}
                </Grid>
            </Box>

            {Object.keys(productsByCategory).filter(category => category !== 'Other').concat('Other')?.map(category => (
                <Box id={category} key={category} sx={{ marginBottom: 6 }}>
                    <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 'bold', color: '#333', letterSpacing: 1 }}>
                        {category}
                    </Typography>
                    <Divider sx={{ mb: 2 }} />
                    <Grid container spacing={4}>
                        {productsByCategory[category]?.map(product => (
                            <Grid item xs={12} sm={6} md={4} lg={3} key={product.position}>
                                <Card
                                    sx={{
                                        height: '100%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'space-between',
                                        backgroundColor: '#ffffff',
                                        boxShadow: 3,
                                        '&:hover': { boxShadow: 6 },
                                    }}
                                >
                                    <CardMedia
                                        component="img"
                                        image={product.image}
                                        alt={product.name}
                                        sx={{
                                            width: '100%',
                                            height: 350,
                                            objectFit: 'cover',
                                            borderRadius: '4px 4px 0 0',
                                        }}
                                    />
                                    <CardContent sx={{ flexGrow: 1 }}>
                                        <Typography
                                            variant="h6"
                                            component="h2"
                                            gutterBottom
                                            sx={{
                                                display: '-webkit-box',
                                                WebkitBoxOrient: 'vertical',
                                                WebkitLineClamp: 2,
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                            }}
                                        >
                                            {product.name}
                                        </Typography>
                                        <Typography variant="body1" color="text.secondary">
                                            {product.currency} {product.price}
                                        </Typography>
                                    </CardContent>
                                    <CardActions sx={{ justifyContent: 'center', pb: 2 }}>
                                        <Button
                                            size="small"
                                            color="primary"
                                            variant='contained'
                                            href={product.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            View on Etsy
                                        </Button>
                                    </CardActions>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            ))}
        </Box>
    );
};

export default Products;
